import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"

//E-commerce
import ecommerce from "./e-commerce/reducer"

//Calendar
import calendar from "./calendar/reducer"

//chat
import chat from "./chat/reducer"

//crypto
import crypto from "./crypto/reducer"

//invoices
import invoices from "./invoices/reducer"

//jobs
import JobReducer from "./jobs/reducer"

//projects
import projects from "./projects/reducer"

//tasks
import tasks from "./tasks/reducer"

//contacts
import contacts from "./contacts/reducer"

//mails
import mails from "./mails/reducer"

//Dashboard
import Dashboard from "./dashboard/reducer"

//Dasboard saas
import DashboardSaas from "./dashboard-saas/reducer"

//Dasboard crypto
import DashboardCrypto from "./dashboard-crypto/reducer"

//Dasboard blog
import DashboardBlog from "./dashboard-blog/reducer"

//Dasboard job
import DashboardJob from "./dashboard-jobs/reducer"

//auth
import AuthReducer from "../toolkitStore/authSlice"

//event management
import EventReducer from "../toolkitStore/eventMSlice/eventSlice"
import TicketReducer from "../toolkitStore/ticketMSlice/ticketSlice"
import eventTypes from "../toolkitStore/eventTypeSlice"
import VenueReducer from "../toolkitStore/eventMSlice/VenueSlice"
import TicketVenueReducer from  "../toolkitStore/ticketMSlice/TicketVenueSlice"
import OrganiserReducer from "toolkitStore/eventMSlice/OrganiserSlice"
import SeatAllocationReducer from "../toolkitStore/eventMSlice/SeatAllocationSlice"

//fetna management
import FetnaReducer from "../toolkitStore/FetnaSlice/fetnaSlice"
import FetnaUserReducer from "../toolkitStore/FetnaSlice/FetnaUserSlice"
import DayReducer from "../toolkitStore/FetnaSlice/DaySlice"
import LocationReducer from "../toolkitStore/FetnaSlice/LocationSlice"
import HallReducer from "../toolkitStore/FetnaSlice/HallSlice"
import AgendaReducer from "../toolkitStore/FetnaSlice/AgendaSlice"
import AgendaOrganiserReducer from "../toolkitStore/FetnaSlice/AgendaOrganiserSlice"
import AttractionReducer from "../toolkitStore/FetnaSlice/AttractionSlice"

//SeatMap
import SeatReducer from "toolkitStore/SeatArrangement/SeatSlice"
//Member Management
import MemberTypeReducer from "toolkitStore/MemberMagement/MemberTypeSlice"
import MemberReducer from "toolkitStore/MemberMagement/MemberSlice"
//Committee
import ExecutiveReducer from "toolkitStore/CommitteeSlice/ExecutiveSlice"
//News Management
import NewsLetterReducer from "toolkitStore/NewsSlice/NewsLetterSlice"
import SubscriberReducer from "toolkitStore/NewsSlice/SubscriberSlice"
//Sponor
import SponsorReducer from "toolkitStore/SponsorSlice"
//AdMin Magnagement
import AdminReducer from "toolkitStore/admin/AdminSlice"
//Banner Magnagement
import BannerReducer from "toolkitStore/Banner/BannerSlice"
//Gallery MAnagement
import GalleryReducer from "toolkitStore/GallerySlice"
//MalligaiMalar
import MalligaiMalarReducer from "toolkitStore/MalligaiMalarSlice"
//YouthWing
import YouthWingReducer from "toolkitStore/YouthWingSlice"
import DonateReducer from "toolkitStore/DonateSlice"
const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  ecommerce,
  calendar,
  chat,
  mails,
  crypto,
  invoices,
  JobReducer,
  projects,
  tasks,
  contacts,
  Dashboard,
  DashboardSaas,
  DashboardCrypto,
  DashboardBlog,
  DashboardJob,
  //auth
  AuthReducer,
  //Event Mangement
  EventReducer,
  // Ticket Management
  TicketReducer,
  eventTypes,
  VenueReducer,
  TicketVenueReducer,
  OrganiserReducer,
  SeatAllocationReducer,
  //Fetna Mangement
  FetnaReducer,
  FetnaUserReducer,
  DayReducer,
  LocationReducer,
  HallReducer,
  AgendaReducer,
  AgendaOrganiserReducer,
  AttractionReducer,
  //SeatMap
  SeatReducer,
  //Member Management
  MemberTypeReducer,
  MemberReducer,
  //SATS Team
  ExecutiveReducer,
  //News Magement
  NewsLetterReducer,
  SubscriberReducer,
  //Sponsor
  SponsorReducer,
  //Admin
  AdminReducer,
  // Banner
  BannerReducer,
  //Gallery
  GalleryReducer,
  //MalligaiMalar
  MalligaiMalarReducer,
  //YouthWing
  YouthWingReducer,
  DonateReducer,
})

export default rootReducer
